// extracted by mini-css-extract-plugin
export var IOMLogos = "Footer-module--IOMLogos--710b3";
export var brand = "Footer-module--brand--77450";
export var button = "Footer-module--button--bf5ae";
export var buttonTextAndLabel = "Footer-module--buttonTextAndLabel--24939";
export var buttons = "Footer-module--buttons--6d550";
export var compact = "Footer-module--compact--ec945";
export var compactFooterSection = "Footer-module--compactFooterSection--e942e";
export var compactInfoContent = "Footer-module--compactInfoContent--f0a4f";
export var container = "Footer-module--container--d5d86";
export var download = "Footer-module--download--103bc";
export var expanded = "Footer-module--expanded--4aaf7";
export var hideMinWidthDesktop = "Footer-module--hideMinWidthDesktop--bcb4e";
export var info = "Footer-module--info--5e2d3";
export var isIOM = "Footer-module--isIOM--07996";
export var label = "Footer-module--label--f3e23";
export var link = "Footer-module--link--36401";
export var links = "Footer-module--links--15c69";
export var logo = "Footer-module--logo--fb195";
export var mobileTextContent = "Footer-module--mobileTextContent--fb82f";
export var qr = "Footer-module--qr--2f5b3";
export var sacop = "Footer-module--sacop--a118c";
export var section = "Footer-module--section--3ba37";
export var showMinWidthDesktop = "Footer-module--showMinWidthDesktop--9f0d3";
export var social = "Footer-module--social--7285f";
export var storeIcon = "Footer-module--storeIcon--15a96";